import React from 'react';

import { IIconProps, TIconType } from '../interface';

const AddIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
			{...props?.innerSvgProps}
		>
			<path
				d='M5 10H15'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10 5V15'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<rect
				height='19'
				rx='9.5'
				stroke='#2E2E6B'
				width='19'
				x='0.5'
				y='0.5'
			/>
		</svg>
	);
};

export default AddIcon;
